module.exports = __webpack_public_path__ + "static/media/image3.cd5a1afd.jpeg";